import React, { useEffect, useState } from "react";
import { getBalances } from "../../services/firebase";

export default function Balance() {
  const [data, setData] = useState([]);
  const [summ, setSumm] = useState(0);

  useEffect(() => {
    getBalances().then((resp) => {
      setData(resp);
      let sum = 0;
      resp.forEach((element) => {
        Object.values(element.value).forEach((item) => {
          sum += parseInt(item.Amount);
        });
      });
      setSumm(sum);
    });
  }, []);

  return (
    <div>
      <div>Summ {summ}</div>
      Balance
      {data.map((val) => {
        return (
          <div style={{ marginBottom: "2%" }}>
            <span> {val.key}</span>
            {Object.values(val.value).map((elem) => {
              return (
                <div
                  style={{
                    margin: "0 auto",
                    textAlign: "center",
                    borderStyle: "solid",
                    bordetWidth: 1,
                    borderColor: "black",
                    width: "20%",
                  }}
                >
                  <div>Amount {elem.Amount}</div>
                  <div>type {elem.type}</div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
